(function () {
  var medicalBtn = document.getElementById('stepsToggleMedical');
  var aestheticBtn = document.getElementById('stepsToggleAesthetic');
  var medicalSection = document.querySelector('[data-name="process-medical"]');
  var aestheticSection = document.querySelector('[data-name="process-cosmetic"]');

  if (!medicalBtn || !aestheticBtn || !medicalSection || !aestheticSection) {
    document.querySelector('.steps-toggle')?.remove();
    return;
  }

  medicalBtn.type = 'button';
  aestheticBtn.type = 'button';

  function setMedical() {
    medicalBtn.classList.add('active');
    aestheticBtn.classList.remove('active');
    medicalBtn.setAttribute('aria-pressed', 'true');
    aestheticBtn.setAttribute('aria-pressed', 'false');
    medicalSection.classList.remove('steps-toggle-target--hidden');
    aestheticSection.classList.add('steps-toggle-target--hidden');
  }

  function setAesthetic() {
    aestheticBtn.classList.add('active');
    medicalBtn.classList.remove('active');
    aestheticBtn.setAttribute('aria-pressed', 'true');
    medicalBtn.setAttribute('aria-pressed', 'false');
    aestheticSection.classList.remove('steps-toggle-target--hidden');
    medicalSection.classList.add('steps-toggle-target--hidden');
  }

  medicalBtn.addEventListener('click', setMedical);
  aestheticBtn.addEventListener('click', setAesthetic);

  setMedical();
})();

(function () {
  var dialog = document.getElementById('jotform-appointment-request');
  if (!dialog) return;

  var iframe = dialog.querySelector('iframe');
  var closeBtn = dialog.querySelector('.custom-dialog__close');

  function openDialog() {
    if (iframe.src === 'about:blank') iframe.src = iframe.dataset.src;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  function closeDialog() {
    dialog.close();
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#jotform-appointment-request"]');
    if (!link) return;
    e.preventDefault();
    openDialog();
  });

  closeBtn.addEventListener('click', closeDialog);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeDialog();
  });

  dialog.addEventListener('cancel', function () {
    document.body.style.overflow = '';
  });
})();
